import clsx from 'clsx';
import { useGlobalQueries } from '@/hooks/use-global-queries';
import { FooterBottom } from './components/footer-bottom';
import { FooterTop } from './components/footer-top';
import { Wave } from './components/wave';
import { getTailwindColor } from '@/utils/colors';

export const Footer = () => {
    const { pageQuery } = useGlobalQueries();

    if (pageQuery?.data?.remove_footer) {
        return null;
    }

    return (
        <footer className={clsx(getTailwindColor(pageQuery.data?.page_background_color, 'bg'))}>
            <Wave />
            <div className="-r-mt-1 r-bg-tertiary-500 max-md:r-pt-10">
                <FooterTop />
                <FooterBottom />
            </div>
        </footer>
    );
};
